export const GET_LIVE_EVENT_INFO_START = 'GET_LIVE_EVENT_INFO_START';
export const GET_LIVE_EVENT_INFO_SUCCESS = 'GET_LIVE_EVENT_INFO_SUCCESS';
export const GET_LIVE_EVENT_INFO_ERROR = 'GET_LIVE_EVENT_INFO_ERROR';

export const START_OVER_CURRENT_EVENT_START = 'START_OVER_CURRENT_EVENT_START';
export const START_OVER_CURRENT_EVENT_SUCCESS =
  'START_OVER_CURRENT_EVENT_SUCCESS';
export const START_OVER_CURRENT_EVENT_ERROR = 'START_OVER_CURRENT_EVENT_ERROR';
export const SET_TIMESHIFT_EVENT_INFO = 'SET_TIMESHIFT_EVENT_INFO';
export const CLEAR_TIMESHIFT_EVENT_INFO = 'CLEAR_TIMESHIFT_EVENT_INFO';
